<div class="card-header py-3">
    <h6 class="m-0 font-weight-bold text-primary">{{ 'ticket-in-desk-and-categories-stats' | translate}}</h6>
</div>
<div class="card-body">
    <mat-form-field class="mr-2">
        <mat-label>{{ 'desk' | translate }}</mat-label>
        <mat-select matNativeControl [(ngModel)]="selectedDeskId" (selectionChange)="changeDeskOrCategory()">
            <mat-option *ngFor="let desk of desks" [value]="desk.id">
                {{ desk.fullName }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field>
        <mat-label>{{ 'category' | translate }}</mat-label>
        <mat-select matNativeControl [(ngModel)]="selectedCategoryId" (selectionChange)="changeDeskOrCategory()">
            <mat-option *ngFor="let category of categories" [value]="category.id">
                {{ category.fullName | translate }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <div *ngIf="processedDeskAndCategoriesTicketsCounts[selectedDeskId] &&
        processedDeskAndCategoriesTicketsCounts[selectedDeskId][selectedCategoryId]">
        <h4 class="small font-weight-bold">{{ 'accepted' | translate }}
            <span class="float-right">{{ processedDeskAndCategoriesTicketsCounts[selectedDeskId][selectedCategoryId].acceptedTicketsCount }}</span>
        </h4>
        <div class="progress mb-4">
            <div class="progress-bar bg-success" role="progressbar" aria-valuemin="0" aria-valuemax="maxTickets"
                aria-valuenow="processedDeskAndCategoriesTicketsCounts[selectedDeskId][selectedCategoryId].acceptedTicketsCount"
                [style.width]="(processedDeskAndCategoriesTicketsCounts[selectedDeskId][selectedCategoryId].acceptedTicketsCount/maxTickets)*100 + '%'">
            </div>
        </div>
        <h4 class="small font-weight-bold">{{ 'redirected' | translate }}
            <span class="float-right">{{ processedDeskAndCategoriesTicketsCounts[selectedDeskId][selectedCategoryId].redirectedTicketsCount }}</span>
        </h4>
        <div class="progress mb-4">
            <div class="progress-bar bg-primary" role="progressbar" aria-valuemin="0" aria-valuemax="maxTickets"
                aria-valuenow="processedDeskAndCategoriesTicketsCounts[selectedDeskId][selectedCategoryId].redirectedTicketsCount"
                [style.width]="(processedDeskAndCategoriesTicketsCounts[selectedDeskId][selectedCategoryId].redirectedTicketsCount/maxTickets)*100 + '%'">
            </div>
        </div>
        <h4 class="small font-weight-bold">{{ 'cancelled' | translate }}
            <span class="float-right">{{ processedDeskAndCategoriesTicketsCounts[selectedDeskId][selectedCategoryId].cancelledTicketsCount }}</span>
        </h4>
        <div class="progress mb-4">
            <div class="progress-bar bg-danger" role="progressbar" aria-valuemin="0" aria-valuemax="maxTickets"
                aria-valuenow="processedDeskAndCategoriesTicketsCounts[selectedDeskId][selectedCategoryId].cancelledTicketsCount"
                [style.width]="(processedDeskAndCategoriesTicketsCounts[selectedDeskId][selectedCategoryId].cancelledTicketsCount/maxTickets)*100 + '%'">
            </div>
        </div>
    </div>
    <div *ngIf="!processedDeskAndCategoriesTicketsCounts[selectedDeskId] ||
        !processedDeskAndCategoriesTicketsCounts[selectedDeskId][selectedCategoryId]">
        {{ 'no-tickets' | translate }}
    </div>
</div>